export default "__VITE_ASSET__c5596a93__"